import { handleActions } from 'redux-actions';
import {
  changeScreenOrientation,
  createAddressSuccess,
  deleteAddressSuccess,
  editAddressSuccess,
  hidePasswordSuccess,
  postProfileSettingsSuccess,
  removeBanner,
  removeBannerFailed,
  removeBannerSuccess,
  removeImage,
  removeImageFailed,
  removeImageSuccess,
  requestPersonalInfo,
  requestPersonalInfoFailed,
  requestPersonalInfoSuccess,
  requestUser,
  requestUserFailed,
  requestUserImage,
  requestUserImageFailed,
  requestUserImageSuccess,
  requestUserSuccess,
  setBrowserOnline,
  showFooterNavbar,
  toggleMobileMenu,
  updateBanner,
  updateBannerFailed,
  updateBannerSuccess,
  updateImage,
  updateImageFailed,
  updateImageSuccess,
  updatePassword,
  updatePasswordFailed,
  updatePasswordSuccess,
  updateUser,
  updateUserFailed,
  updateUserSuccess,
} from '../actions/userActions';

const initialState = {
  deviceHeight: 0,
  deviceOrientation: '',
  deviceWidth: 0,
  error: false,
  errorText: '',
  isBrowserOnline: true,
  isMobileMenuOpen: false,
  isShowFooterNavbar: true,
  loading: false,
  passwordUpdateSuccess: false,
  pendingUserImageUpdate: false,
  pendingUserInfoUpdate: false,
  userInfo: {
    addresses: [],
    bannerUrl: null,
    birthDate: null,
    email: '',
    firstName: 'Имя',
    id: '',
    imageUrl: '',
    keywordsMap: {},
    lastName: 'Фамилия',
    nickname: '',
    phone: null,
    settings: {},
  },
};

const userHandler = {
  [changeScreenOrientation]: (state, { payload }) => {
    return {
      ...state,
      deviceHeight: payload.height,
      deviceOrientation: payload.orientation,
      deviceWidth: payload.width,
    };
  },
  [createAddressSuccess]: (state, { payload }) => {
    return {
      ...state,
      userInfo: { ...state.userInfo, addresses: [...state.userInfo.addresses, payload] },
    };
  },
  [deleteAddressSuccess]: (state, { payload }) => {
    return {
      ...state,
      userInfo: {
        ...state.userInfo,
        addresses: [...state.userInfo.addresses.filter((address) => address.id !== payload)],
      },
    };
  },
  [editAddressSuccess]: (state, { payload }) => {
    return {
      ...state,
      userInfo: {
        ...state.userInfo,
        addresses: [
          ...state.userInfo.addresses.map((address) =>
            address.id === payload?.id ? { ...address, ...payload } : address
          ),
        ],
      },
    };
  },
  [hidePasswordSuccess]: (state, { status }) => {
    return { ...state, passwordUpdateSuccess: status };
  },
  [postProfileSettingsSuccess]: (state, { payload }) => {
    return {
      ...state,
      userInfo: { ...state.userInfo, settings: { ...state.userInfo.settings, ...payload } },
    };
  },
  [removeBanner]: (state) => {
    return { ...state, loading: true };
  },
  [removeBannerFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [removeBannerSuccess]: (state, { payload }) => {
    const newInfo = { ...state.userInfo, bannerUrl: state.initialState };
    return { ...state, loading: false, userInfo: newInfo };
  },
  [removeImage]: (state) => {
    return { ...state, loading: true };
  },
  [removeImageFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [removeImageSuccess]: (state, { payload }) => {
    const newInfo = { ...state.userInfo, imageUrl: '' };
    return { ...state, loading: false, userAvatar: null, userInfo: newInfo };
  },
  [requestPersonalInfo]: (state, { payload }) => {
    return { ...state, loading: true };
  },
  [requestPersonalInfoFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [requestPersonalInfoSuccess]: (state, { payload }) => {
    return { ...state, loading: false, userInfo: payload };
  },
  [requestUser]: (state, { payload }) => {
    return { ...state, loading: true };
  },
  [requestUserFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [requestUserImage]: (state, { payload }) => {
    return { ...state };
  },
  [requestUserImageFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [requestUserImageSuccess]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      userAvatar: payload,
    };
  },
  [requestUserSuccess]: (state, { payload }) => {
    const { data, isOwnProfile } = payload;
    const newState = isOwnProfile ? { ...state, loading: false, userInfo: data } : { ...state, loading: false };
    return newState;
  },
  [setBrowserOnline]: (state, { payload }) => {
    return { ...state, isBrowserOnline: payload };
  },
  [showFooterNavbar]: (state, { payload }) => {
    return { ...state, isShowFooterNavbar: payload };
  },
  [toggleMobileMenu]: (state) => {
    return { ...state, isMobileMenuOpen: !state.isMobileMenuOpen };
  },
  [updateBanner]: (state, { payload: { updateInfo } }) => {
    return { ...state, loading: true };
  },
  [updateBannerFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [updateBannerSuccess]: (state, { payload }) => {
    return { ...state, loading: false };
  },
  [updateImage]: (state, { payload: { updateInfo } }) => {
    return { ...state, loading: true };
  },
  [updateImageFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [updateImageSuccess]: (state, { payload }) => {
    const isBrowserOnline = state.isBrowserOnline;
    let offlineImage = state.offlineImage;
    let userAvatar = state.userAvatar;
    let pendingUserImageUpdate;
    if (payload && !isBrowserOnline) {
      offlineImage = payload.croppedImage;
      userAvatar = payload.userAvatar;
      pendingUserImageUpdate = true;
    } else {
      pendingUserImageUpdate = false;
    }
    return { ...state, loading: false, offlineImage, pendingUserImageUpdate, userAvatar };
  },
  [updatePassword]: (state, { payload: { updateInfo } }) => {
    return { ...state, loading: true };
  },
  [updatePasswordFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false, passwordUpdateSuccess: false };
  },
  [updatePasswordSuccess]: (state, { payload }) => {
    return {
      ...state,
      error: false,
      errorText: '',
      loading: false,
      passwordUpdateSuccess: true,
    };
  },
  [updateUser]: (state, { payload }) => {
    return { ...state, loading: true };
  },
  [updateUserFailed]: (state, { message }) => {
    return { ...state, error: true, errorText: message, loading: false };
  },
  [updateUserSuccess]: (state, { payload }) => {
    let userInfo = state.userInfo;
    let pendingUserInfoUpdate;
    if (payload && payload.isOffline) {
      userInfo = payload.userInfo;
      pendingUserInfoUpdate = true;
    } else {
      pendingUserInfoUpdate = false;
    }
    return {
      ...state,
      loading: false,
      pendingUserInfoUpdate,
      userInfo,
    };
  },
};

const userReducer = handleActions(userHandler, initialState);

export default userReducer;
